<script lang="ts">
    import { getAttachement, getOneOperation } from "../../api"
    import { accessToken as accessTokenStore } from "../../store"
    import { _ } from "svelte-i18n"
    import OperationHead from "../routes/operations/OperationHead.svelte"
    import OperationsLegend from "../routes/operations/OperationsLegend.svelte"
    import OperationPositions from "../routes/operations/OperationPositions.svelte"

    export let id: string
    export let collectionName: string
    export let accessToken: string

    $accessTokenStore = accessToken

    let fehler = false
    let activePosition: number
    let operation: Operation | OperationOut
    let attachmentsProm: {
        [opId: string]: Promise<{ count?: number; data: Attachement[] }>
    } = {}

    const getOperation = async () => {
        try {
            operation = await getOneOperation(id + "?accessToken=" + $accessTokenStore, collectionName, {
                projection: "token",
            })
        } catch (e) {
            // Ohne dieses try/catch erzeugte ein ungueltiger Token einen
            // unbehandelten Rejection-Fehler: der Browser meldete
            // `[pageerror] Object`, und weil das Markup komplett hinter
            // `{#if operation}` liegt, blieb die Seite weiss und stumm. Wer den
            // Link per E-Mail bekommen hat und der nicht mehr passt, sah nichts.
            // Anmerkung zum Text: `_` ist in svelte-i18n 4 ein Store, im Script
            // also nicht aufrufbar – deshalb steht der Text ueber `$_` im
            // Markup und nicht in einer Meldung oben rechts.
            fehler = true
        }
    }
    getOperation()

    async function loadAttachments(op: Operation | OperationOut) {
        if (!attachmentsProm[op.id]) {
            attachmentsProm[op.id] = getAttachement(
                collectionName == "operation-out" ? op.id : op.number,
                $accessTokenStore
            )
        }
        try {
            const res = await attachmentsProm[op.id]
            if (collectionName == "operation-out") {
                await getAttachement(op.id, $accessTokenStore).then((r) => {
                    r.data.forEach((f) => {
                        if (
                            f?.name?.toLowerCase()?.includes("jpg") ||
                            f?.name?.toLowerCase()?.includes("jpeg") ||
                            f?.name?.toLowerCase()?.includes("png")
                        ) {
                            if (res.data.find((e) => e.name == f.name)) return
                            res.data.push(f)
                        }
                    })
                })
            }
            return res.data
        } catch (e) {}
        return []
    }
    //$: console.log(operation)
</script>

{#if fehler}
    <!-- Kein `lang` an data-lang: die Komponente hat keine Sprach-Prop
         (nur id, collectionName, accessToken) – svelte-check sagt es. -->
    <section class="section_padding">
        <div class="container_wide">
            <h1>{$_("operations.shareLinkInvalid")}</h1>
        </div>
    </section>
{:else if operation}
    <div id="shared-operation">
        <div class="meta">
            <h1 class="offer-id">
                {operation.type === 2 ? $_("general.order") : $_("general.offer")}: {operation.number}
            </h1>
            <h2 class="commission">{$_("general.commission")}: {operation.commission || ""}</h2>
        </div>
        <OperationHead {operation} sharedView="{true}" />

        <OperationPositions {operation} bind:activePosition {loadAttachments} sharedView="{true}" />
        <OperationsLegend type="{operation.type}" sharedView="{true}" />
    </div>
{/if}
